import {
    get,
    put,
    putWithQuery,
    post,
    Delete,
    axios,
} from "../ApiDecorator";

/**
 * 精彩瞬间（管理端）
 * 网关：/course/moment
 */
const Moment = {
    /** POST 新建精彩瞬间设置 */
    createTemplate(data) {
        return post("/course/moment/template/create", data);
    },
    /** GET 按项目查询模板列表 */
    getTemplateList(data) {
        return get("/course/moment/template/list", data);
    },
    /** PUT 修改启用状态 */
    setTemplateStatus(data) {
        return putWithQuery("/course/moment/template/status", {}, data);
    },
    /** GET 模板详情回显 */
    getTemplateDetail(data) {
        return get("/course/moment/template/detail", data);
    },
    /** PUT 编辑模板设置 */
    updateTemplate(data) {
        return put("/course/moment/template/update", data);
    },
    /** DELETE 删除模板设置 */
    deleteTemplate(data) {
        return Delete("/course/moment/template/delete", data);
    },
    /** GET 精彩瞬间提交明细导出（blob） */
    exportDetail(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/course/moment/template/exportDetail?${query}`, {
            responseType: "blob",
        });
    },
    /** GET 精彩瞬间次数统计导出（blob） */
    exportUserFillCount(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/course/moment/template/exportUserFillCount?${query}`, {
            responseType: "blob",
        });
    },
    /** GET 某日已正式提交概况与明细 */
    getDayOverview(data) {
        return get("/course/moment/day/submitOverview", data);
    },
    /** PUT 标记 / 取消精选（query: id, isFeatured） */
    setFileFeatured(data) {
        return putWithQuery("/course/moment/day/file/featured", {}, {
            id: data.id,
            isFeatured: data.isFeatured === 1 || data.isFeatured === '1' || data.isFeatured === true ? 1 : 0,
        });
    },

    // ===== 学员端接口 =====
    /** GET 我的精彩瞬间列表（按模板分组，含每天answerStatus） */
    getUserList(data) {
        return get("/course/moment/user/list", data);
    },
    /** GET 填写回显（草稿+正式提交） */
    getFillDetail(data) {
        return get("/course/moment/user/fill/detail", data);
    },
    /** POST 保存草稿/正式提交（新建） */
    saveFill(data) {
        return post("/course/moment/user/fill/save", data);
    },
    /** POST 编辑自己的提交（已有记录后修改） */
    editFill(data) {
        return post("/course/moment/user/fill/edit", data);
    },
};

export default Moment;
